import React, { useEffect, useState } from "react";
import { Avatar, Box, Checkbox, CircularProgress, Dialog, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Typography } 
from "@mui/material"; 
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import dayjs from "dayjs";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import { dashboardText, icon34, mainGrid, paddingbox, pointer } from "../../style2";



export default function SleepDiary(props) {
    // If startDate and endDate are supplied via props, the component operates in
    // date-range mode: it calls a different API endpoint, hides the month/year
    // selectors, and displays the date range in the heading instead.
    // When these props are absent, the default year/month selector behaviour applies.
    const { startDate, endDate } = props;
    const useDateRange = startDate && endDate;
    const [selectedYear, setSelectYear] = useState(dayjs().year());
    const [selectedMonth, setSelectMonth] = useState(0);
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedEntry, setSelectedEntry] = useState(null);
    const ls = new AccessLocalStorage();

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }

        const url = useDateRange
            ? `${getApiUrl()}/sleepdiary/getbydate/${ls.getCurrentPatientId()}?sd=${startDate}&ed=${endDate}`
            : `${getApiUrl()}/sleepdiary/${ls.getCurrentPatientId()}/${selectedYear}/${selectedMonth}`;

        fetch(url,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                let result = [];
                data.forEach((e) => {
                    if (!e.isDeleted) {
                        result.push(e);
                    }

                });
                data.forEach((e) => {
                    if (e.isDeleted)
                        result.push(e);
                });
                setEntries(result);
            })
            .catch((err) => {
                setError(err.message || "An error occurred.");
                setEntries([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedYear, selectedMonth, props.newJournalCreatedTime, startDate, endDate]);

    const renderYearOptions = () => {
        let items = [];
        let d = new Date(Date.now());
        for (let i = d.getFullYear(); i > d.getFullYear() - 25; i--) {
            items.push(<MenuItem value={i}>{i}</MenuItem>);
        }
        return items;
    }

    const renderMonthName = () => {
        switch (selectedMonth) {
            case 0:
                return "";
            case 1:
                return "Jan ";
            case 2:
                return "Feb ";
            case 3:
                return "Mar ";
            case 4:
                return "Apr ";
            case 5:
                return "May ";
            case 6:
                return "Jun ";
            case 7:
                return "Jul";
            case 8:
                return "Aug ";
            case 9:
                return "Sep ";
            case 10:
                return "Oct ";
            case 11:
                return "Nov ";
            case 12:
                return "Dec ";

        }
    }

    const renderShowEntry = () => {
        if (selectedEntry !== null) {
            //console.log(selectedEntry);
            return <Dialog open={true} onClose={() => { setSelectedEntry(null); }} fullWidth maxWidth="sm">
                <Grid container sx={{ backgroundColor: "#fff", padding: "10px" }}>
                    <Grid item xs={11} >
                        <Typography title="Entry Date" sx={{ fontWeight: "bold", color: "rgb(241, 111, 111)", fontSize: "17px" }}>
                            Sleep Diary - {dayjs(selectedEntry.journalDate).format("DD/MM/YY")}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "right", ...pointer }}>
                        <CloseIcon onClick={() => { setSelectedEntry(null); }} />
                    </Grid>
                </Grid>
                <Grid sx={{ padding: "10px" }}>
                    <table style={{ width: "400px" }} cellPadding={3}>
                        <thead>
                            <tr>
                                <th align="left" >Event</th>
                                <th align="left">Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Put to Bed</td>
                                <td>{dayjs(selectedEntry.putToBed).format("h:mm A")}</td>
                            </tr>
                            <tr>
                                <td>Fell Asleep</td>
                                <td>{dayjs(selectedEntry.fellAsleep).format("h:mm A")}</td>
                            </tr>
                            {selectedEntry.wokeUpEntries.map((woke) => {
                                return <>
                                    <tr>
                                        <td>Woke Up</td>
                                        <td>{dayjs(woke.wokeUp).format("h:mm A")}</td>
                                    </tr>
                                    {woke.fellAsleep !== null ? <tr>
                                        <td>Fell Asleep</td>
                                        <td>{dayjs(woke.fellAsleep).format("h:mm A")}</td>
                                    </tr> : null}
                                </>
                            })}
                        </tbody>
                    </table>
                    {selectedEntry.totalTimeAwake !== "" ? <Typography title="" style={{ paddingTop: "4px", color: "rgb(241, 111, 111)", fontSize: "17px" }}>
                        Awake Time -  {selectedEntry.totalTimeAwake}
                    </Typography> : null}
                    {selectedEntry.note !== "" && selectedEntry.note !== null ? <Box style={{ padding: "10px 5px", margin: "10px 0px ", borderTop: "1px solid gainsboro", borderBottom: "1px solid gainsboro" }}>
                        <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px" }}>{selectedEntry.note}</Typography>
                    </Box> : null}
                    <Grid container fullWidth style={{ marginTop: "10px", padding: "10px 0px" }}>
                        <Grid item xs={6}>
                            <Typography style={{ color: "rgb(84, 84, 84)", fontSize: "15px" }}>
                                <span style={{marginRight:"15px"}}>Created on</span> {moment.utc(selectedEntry.createdAt).local().format("DD/MM/YYYY h:mm A")}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography style={{ color: "rgb(84, 84, 84)", fontSize: "15px", textAlign: "right" }}>
                                Entered by - {selectedEntry.createdByName}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Dialog>;
        }
        return null;
    }

    return (<Box sx={(props.fullWidth ? null : paddingbox)} id={props.id}>
        <Grid container>
            <Grid item xs={12} container>
                <Grid item xs={useDateRange ? 12 : 8}>
                    <Box display="flex" alignItems="center" sx={dashboardText}>
                        <Box component="img" src={props.icon ? props.icon : `assets/sleep-diary.png`} sx={icon34}></Box> <Box mr={1} />
                        <Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>
                            {useDateRange
                                ? `Sleep Diary - ${dayjs(startDate).format("DD/MM/YY")} to ${dayjs(endDate).format("DD/MM/YY")}`
                                : `Sleep Diary - ${renderMonthName()}${selectedYear}`}
                        </Typography>
                        {loading ? <span style={{ marginLeft: 10 }}><CircularProgress size={20} /></span> : null}
                    </Box>
                </Grid>
                {!useDateRange && (
                    <>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 120, paddingRight:1 }} size="small">
                                <InputLabel id="sleepdiary-month-select-label">Month</InputLabel>
                                <Select disabled={loading} labelId="sleepdiary-month-select-label"
                                    id="sleep-diary-month-select" value={selectedMonth} label="Month" onChange={(event) => { setSelectMonth(event.target.value); }}>
                                    <MenuItem value={0}>Month</MenuItem>
                                    <MenuItem value={1}>Jan</MenuItem>
                                    <MenuItem value={2}>Feb</MenuItem>
                                    <MenuItem value={3}>Mar</MenuItem>
                                    <MenuItem value={4}>Apr</MenuItem>
                                    <MenuItem value={5}>May</MenuItem>
                                    <MenuItem value={6}>Jun</MenuItem>
                                    <MenuItem value={7}>Jul</MenuItem>
                                    <MenuItem value={8}>Aug</MenuItem>
                                    <MenuItem value={9}>Sep</MenuItem>
                                    <MenuItem value={10}>Oct</MenuItem>
                                    <MenuItem value={11}>Nov</MenuItem>
                                    <MenuItem value={12}>Dec</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 120 }} size="small">
                                <InputLabel id="sleepdiary-year-select-label">Year</InputLabel>
                                <Select disabled={loading} labelId="sleepdiary-year-select-label"
                                    id="sleep-diary-year-select" value={selectedYear} label="Year" onChange={(event) => { setSelectYear(event.target.value); }}>
                                    {renderYearOptions()}
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                )}
            </Grid>
            <Box m={1} />
            <Grid item xs={12}>
                <Box sx={{...mainGrid, padding: "20px", overflowX: "auto", overflowY: "hidden" }}>
                    {entries.length > 0 ? <table cellPadding={0} cellSpacing={0} >
                        <tbody>
                            <tr>
                                {entries.map((entry) => (
                                    <td key={entry.id} align="center" valign="middle" style={{ padding: "8px", cursor: "pointer" }} onClick={() => { setSelectedEntry(entry); }}>
                                        <div style={{ minHeight: "85px", minWidth: "160px", padding: "5px 10px", background: "#ffffff", borderRadius: "10px", marginBottom: "10px" }}>
                                            <table style={{ width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px" }}>
                                                                Put to Bed
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px" }}>
                                                                {dayjs(entry.putToBed).format("hh:mm A")}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px" }}>
                                                            Fell Asleep
                                                        </Typography></td>
                                                        <td><Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px" }}>
                                                            {dayjs(entry.fellAsleep).format("hh:mm A")}
                                                        </Typography></td>
                                                    </tr>
                                                    {entry.totalTimeAwake !== "" ?
                                                        <tr><td>
                                                            <Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px", color: "rgb(241, 111, 111)" }}>
                                                                Awake Time
                                                            </Typography></td>
                                                            <td>
                                                                <Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px", color: "rgb(241, 111, 111)" }}>
                                                                    {entry.totalTimeAwake}
                                                                </Typography>
                                                            </td> </tr> : null}
                                                </tbody>
                                            </table>

                                        </div>
                                        <Typography title="Entry Date" sx={{fontSize:"0.965rem"}} >
                                            {dayjs(entry.journalDate).format("DD/MM/YY")}
                                        </Typography>
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table> : null}
                    {entries.length == 0 && !loading ? <Typography>No Sleep Diary Entries</Typography> : null}
                    {renderShowEntry()}
                </Box>
            </Grid>
        </Grid>
    </Box>);
}